import React from "react";
import DevelopBannerSection from "../components/Homepage/DevelopPageComponents/DevelopBannerSection";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HealthSliderCard from "../components/HealthcarePageComponent/HealthSliderCard";
import IndusExpert from "../components/IndustriesPageComponents/IndusExpert";
import {
  float1,
  float2,
  keyImg1,
  keyImg2,
  keyImg3,
  keyImg4,
  keyImg5,
  keyImg6,
  mouseSlide10,
  mouseSlide12,
  mouseSlide16,
  mouseSlide9,
  vinayakprofileImg,
} from "../components";
import DevDiff from "../components/Homepage/DevelopPageComponents/DevDiff";
import HealthCareTabSection from "../components/HealthcarePageComponent/HealthCareTabSection";
import HealthcareTabs from "../components/Tabs/HealthcareTabs";
import ExpertButton from "../components/CTA/ExpertButton";
import ScrollingSlide from "../components/MouseScrollingComponent/ScrollingSlide";
function DigitalRetail() {
  var settings = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    speed: 800,
    adaptiveHeight: false,
    infinite: true,
    useTransform: true,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section id="healthCare" className="healthCare retailBg">
      <div className="devTopSection ">
        <DevelopBannerSection
          line1="Adapting Through"
          line2="Contemporary "
          line3="Technological Solutions"
          BannerPara="Retail establishments that neglect the integration of these contemporary solutions face the prospect of lagging behind. Thus, in the present digital era, it becomes imperative to emphasize the modernization of business operations."
        />
        <div className="shapeSvg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
            <g id="Layer_x0020_1">
              <metadata id="CorelCorpID_0Corel-Layer" />
              <path
                className="fil0"
                d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
              />
            </g>
          </svg>
        </div>
      </div>
      <div className="heighlightsSection">
        <div className="container">
          <div className="sectionTitle">
            <h2>Crucial Highlights</h2>
            <p>Revolutionizing the Retail Sector in a 5-Year Span</p>
          </div>
          <div className="row">
            <div className="col-md-4 highlightsBox">
              <h5>$6.54 Trillion</h5>
              <p>Anticipated E-commerce sales projection by 2023</p>
            </div>
            <div className="col-md-4 highlightsBox">
              <h5>95%</h5>
              <p>
                Anticipated surge of E-commerce's dominance in overall purchases
                by 2025
              </p>
            </div>
            <div className="col-md-4 highlightsBox">
              <h5>55%</h5>
              <p>
                Rising trend of Generation Z individuals opting to make
                purchases directly through social media platforms
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="healthServicesSliderWrap retailsServicesSection">
        <div className="container">
          <div className="row sectionFlexHeading mb-5">
            <div className="col-md-8 col-12 mx-auto">
              <div className="sectionTitle text-center">
                <h2>Demand</h2>
                <p className="sectionPara text-center">
                  Importance of Technological Modernization in the Retail
                  Industry
                </p>
              </div>
            </div>
          </div>
          <div className="healthServicesSlider">
            <Slider {...settings} className="slider-with-gap retailSlider">
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Evolution of Consumer Demands"
                  cardPara="In the contemporary landscape, consumers anticipate personalized and seamless shopping journeys across diverse platforms. Technology serves as the means for retailers to fulfill these expectations effectively."
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Escalated Competitive Landscape"
                  cardPara="In the face of competition from both virtual and physical retail rivals, cutting-edge technology offers the means for retailers to distinguish themselves by offering inventive and distinctive shopping encounters."
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Enhanced Inventory Control"
                  cardPara="Real-time monitoring and analysis of inventory enable retailers to finely manage stock levels, prevent stockouts, and mitigate losses stemming from surplus stock."
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Efficiency in Operations"
                  cardPara="From automating labor-intensive tasks to digitizing documentation, technology empowers retailers to streamline operations, diminishing the incidence of errors."
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Amplified Customer Interaction"
                  cardPara="Pioneering technologies such as artificial intelligence and machine learning furnish retailers with valuable insights into consumer behavior, thereby enabling the creation of more captivating and individualized interactions."
                />
              </div>
              <div className="slide-item">
                <HealthSliderCard
                  cardTitle="Streamlined Supply Chain Optimization"
                  cardPara="The deployment of technology aids retailers in optimizing their supply chain management, resulting in amplified efficiency and diminished expenditures."
                />
              </div>
            </Slider>
          </div>
        </div>
      </div>
      <section id="healthCareTabSection">
        <div className="container">
          <HealthCareTabSection
            tabSectionTitle1="Inventory Management"
            tabSectionTitle2="Software"
            tabSectionTitle3="We Provide"
            tabSectionPara="A solution designed to meticulously track inventory, analyze sales patterns, and fine-tune stock levels to avoid both stockouts and overstocking. Tailored for retailers seeking optimal inventory control."
          />
          <HealthcareTabs
            tabTitle1="Point-of-Sale (POS) Software"
            tabTitle2="Enterprise Resource Planning (ERP) Software"
            tabTitle3="E-commerce Platform"
            tabTitle4="Order Management System (OMS)"
            tabContentTitle11="Point-of-Sale (POS) Software"
            contentList11="Transaction Processing"
            contentList12="Inventory Management"
            contentList13="Reporting and Analytics"
            contentList14="Employee Management"
            contentList15="Customer Relationship Management (CRM)"
            contentList16="Multi-Location Support"
            tabContentTitle22="Enterprise Resource Planning (ERP) Software"
            contentList21="Integrated Modules"
            contentList22="Centralized Database"
            contentList23="Finance and Accounting"
            contentList24="Human Resources"
            contentList25="Supply Chain Management"
            contentList26="Manufacturing Management"
            tabContentTitle33="E-commerce Platform"
            contentList31="Storefront Design and Customization"
            contentList32="Product Catalog"
            contentList33="Shopping Cart and Checkout"
            contentList34="Payment Gateway Integration"
            contentList35="Order Management"
            contentList36="Shipping and Fulfillment"
            tabContentTitle44="Order Management System (OMS)"
            contentList41="Order Processing"
            contentList42="Multi-Channel Integration"
            contentList43="Order Fulfillment"
            contentList44="Shipping and Logistics"
            contentList45="Order Tracking"
            contentList46="Customer Service and Communication"
          />
        </div>
      </section>
      <section className="keyAdvantagesSection">
        <div className="container">
          <div className="sectionTitle">
            <h2>Key Advantages</h2>
            <p>The Core Benefits of Online Learning, Anytime and Anywhere</p>
          </div>
          <div className="row gy-5">
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg1} alt="Amplified Efficiency" />
                </div>
                <h5>Amplified Efficiency</h5>
                <p>
                  Software automates both inventory and order management tasks,
                  liberating employees to allocate their efforts to other facets
                  of the business.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg2} alt="Elevated Precision" />
                </div>
                <h5>Elevated Precision</h5>
                <p>
                  Automation substantially curtails the potential for human
                  errors in activities like data input, yielding a decrease in
                  errors and an upsurge in accuracy.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg3} alt="Financial Economies" />
                </div>
                <h5>Financial Economies</h5>
                <p>
                  Software solutions mechanize processes, expedite workflows,
                  curtail labor expenditures, heighten efficiency, and
                  ultimately contribute to substantial cost savings.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg4} alt="Augmented Customer Satisfaction" />
                </div>
                <h5>Augmented Customer Satisfaction</h5>
                <p>
                  Retailers can forge personalized shopping experiences through
                  software solutions, along with precise promotions rooted in
                  purchasing history.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg5} alt="Enhanced Inventory Oversight" />
                </div>
                <h5>Enhanced Inventory Oversight</h5>
                <p>
                  Automation of inventory monitoring mitigates the risks
                  associated with overstocking and shortages, thus fostering
                  elevated sales and revenue generation for retailers.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="keyBenifits">
                <div className="keyImgWrap">
                  <img src={keyImg6} alt="Deeper Insights from Data" />
                </div>
                <h5>Deeper Insights from Data</h5>
                <p>
                  The automation of inventory management translates to reduced
                  susceptibility to overstocking or understocking predicaments,
                  resulting in a surge in sales and revenue opportunities for
                  retailers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
      className="mouseScrollingSliderSection"
      id="mouseScrollingSliderSection"
    >
      <div className="container">
        <div className="sectionTitle">
          <h2>
            {" "}
            Work <span className="textGrade">Portfolio</span>
          </h2>
          <ExpertButton
            rText="Get Project Quote"
            rName="rAnimeBtn qouteBtn"
          />
        </div>
      </div>
      <ScrollingSlide
      scrollSliderImg1={mouseSlide16}
        scrollSliderImg2={mouseSlide9}
        scrollSliderImg3={mouseSlide10}
        scrollSliderImg4={mouseSlide12}
        
      />
    </section>
      <section className="IndusExpertSection">
        <IndusExpert
          cName="Version Next Technologies"
          cSecTitle="Why Hire Version Next Technologies as Branding Partner?"
          profileName="Mr. Vinayak Parab"
          designation="Buisness Head"
          cardTitle1="Innovation"
          cardData1="We brings innovative solutions that leverage cutting-edge technologies to drive business growth and stay ahead of the competition."
          cardTitle2="Integrity"
          cardData2="We uphold the highest standards of integrity, ensuring transparency, honesty, and ethical practices in all our interactions with clients."
          cardTitle3="Customer-Obsession"
          cardData3="Our unwavering focus on delivering exceptional customer experiences sets us apart, as we go above and beyond to meet and exceed client expectations."
          cardTitle4="Quality"
          cardData4="We are committed to delivering top-notch quality in all our services, adhering to industry best practices and rigorous quality control processes to ensure excellence."
          profileImg={vinayakprofileImg}
          linkdinLink="http://linkedin.com/in/vinayak-parab-2a7a8615"
          linkdinIcon="fab fa-linkedin"
        />
      </section>
      <section className="whatMakesSection" id="whatMakesSection">
        <DevDiff
          float1={float1}
          float2={float2}
          Char1="What Makes"
          Char2="us"
          Char3="Different?"
          diffDescription="What sets us apart is our expertise, customization, collaboration, creativity, results-driven approach, and customer-centric focus. We have a highly skilled team, personalized solutions, open communication, innovative ideas, a focus on measurable results, and a dedication to customer satisfaction. These factors combine to deliver outstanding outcomes and exceptional experiences for our clients."
        />
      </section>
    </section>
  );
}

export default DigitalRetail;
